import axios from 'axios';

export default {
  namespaced: true,
  state () {
    return {
      pricingList: {},
    };
  },
  getters: {
    pricingList (state) {
      return state.pricingList;
    },
  },
  actions: {
    async fetchPricingList ({ commit }) {
      try {
        const { data } = await axios.get('/api/contentful/pricingList');

        commit('setPricingList', data);
      } catch (error) {
        console.error('Error fetching pricing list:', error);
      }
    },
  },
  mutations: {
    setPricingList (state, data) {
      state.pricingList = data;
    },
  },
};
